import React from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { ReportCardWrapper, ReportCard, ReportCardTitle, ReportCardSubtitle } from '@/components/custom/report/report-card';
import { ReportKpiWrapper, ReportKpi, ReportKpiHeader, ReportKpiTitle, ReportKpiBody, ReportKpiValue } from '@/components/custom/report/report-kpi';

const REPORT_VARIANTS = [
  { variant: 'default', title: 'Relatorio geral', subtitle: 'Visao consolidada de todos os indicadores' },
  { variant: 'monitor', title: 'Acessos a aulas', subtitle: 'Tempo medio na plataforma' },
  { variant: 'user', title: 'Engajamento de alunos', subtitle: 'Frequencia e participacao' },
  { variant: 'filter', title: 'Funil de conversao', subtitle: 'Etapas do processo seletivo' },
  { variant: 'globe', title: 'Adesao por regiao', subtitle: 'Distribuicao geografica' },
  { variant: 'video', title: 'Aulas ao vivo', subtitle: 'Audiencia e duracao' },
  { variant: 'pencil', title: 'Avaliacoes e provas', subtitle: 'Resultados e estatisticas' },
  { variant: 'mouse', title: 'Funil de acessos', subtitle: 'Cliques e conversoes' }
];

export function ReportsSection() {
  return (
    <ShowcaseSection
      id="reports"
      title="Reports"
      description="Cartoes de relatorio com 8 variantes SVG e KPIs com gradient"
    >
      <ShowcaseItem
        label="ReportCard — 8 variantes"
        description="Cards de relatorio com background SVG icones (default, monitor, user, filter, globe, video, pencil, mouse)"
      >
        <ReportCardWrapper>
          {REPORT_VARIANTS.map(r => (
            <ReportCard
              key={r.variant}
              variant={r.variant}
            >
              <ReportCardTitle>{r.title}</ReportCardTitle>
              <ReportCardSubtitle>{r.subtitle}</ReportCardSubtitle>
            </ReportCard>
          ))}
        </ReportCardWrapper>
      </ShowcaseItem>

      <ShowcaseItem
        label="ReportKpi"
        description="KPIs com gradient + texto destacado, ideal para topo de relatorios"
      >
        <ReportKpiWrapper>
          <ReportKpi>
            <ReportKpiHeader>
              <ReportKpiTitle>Total de alunos ativos</ReportKpiTitle>
            </ReportKpiHeader>
            <ReportKpiBody>
              <ReportKpiValue>1.234</ReportKpiValue>
            </ReportKpiBody>
          </ReportKpi>

          <ReportKpi>
            <ReportKpiHeader>
              <ReportKpiTitle>Taxa de conclusao</ReportKpiTitle>
            </ReportKpiHeader>
            <ReportKpiBody>
              <ReportKpiValue>87%</ReportKpiValue>
            </ReportKpiBody>
          </ReportKpi>

          <ReportKpi>
            <ReportKpiHeader>
              <ReportKpiTitle>Aulas assistidas</ReportKpiTitle>
            </ReportKpiHeader>
            <ReportKpiBody>
              <ReportKpiValue>15.842</ReportKpiValue>
            </ReportKpiBody>
          </ReportKpi>

          <ReportKpi>
            <ReportKpiHeader>
              <ReportKpiTitle>Tempo medio de estudo</ReportKpiTitle>
            </ReportKpiHeader>
            <ReportKpiBody>
              <ReportKpiValue>4h32</ReportKpiValue>
            </ReportKpiBody>
          </ReportKpi>
        </ReportKpiWrapper>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
